import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { formatDateTime } from "@/lib/format";
import { Mail, Download, Copy } from "lucide-react";
import { toast } from "sonner";

export default function NewsletterSubs() {
  const [data, setData] = useState({ items: [], total: 0 });

  useEffect(() => { api.get("/admin/newsletter").then((r) => setData(r.data)); }, []);

  const copyAll = () => {
    navigator.clipboard.writeText(data.items.map((s) => s.email).join(", "));
    toast.success("Alle E-Mail-Adressen kopiert.");
  };

  const exportCsv = () => {
    const rows = [["E-Mail", "Angemeldet am"], ...data.items.map((s) => [s.email, s.created_at])];
    const csv = rows.map((r) => r.map((c) => `"${(c || "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url; a.download = "kontinentzeit-newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <AdminLayout title="Newsletter">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 bg-prussian text-white flex items-center justify-center"><Mail size={20} /></div>
          <div>
            <p className="font-headline font-bold text-2xl text-prussian leading-none" data-testid="subscriber-count">{data.total}</p>
            <p className="text-xs text-muted-foreground uppercase tracking-wide font-body mt-1">Abonnenten gesamt</p>
          </div>
        </div>
        <div className="flex gap-2">
          <button onClick={copyAll} data-testid="copy-emails-btn" className="inline-flex items-center gap-2 border border-edborder bg-white text-prussian text-sm font-body px-4 py-2.5 hover:bg-offwhite"><Copy size={15} /> Kopieren</button>
          <button onClick={exportCsv} data-testid="export-csv-btn" className="inline-flex items-center gap-2 bg-prussian text-white text-sm font-body px-4 py-2.5 hover:bg-prussian-dark"><Download size={15} /> CSV exportieren</button>
        </div>
      </div>

      <div className="bg-white border border-edborder overflow-x-auto" data-testid="newsletter-subscribers-list">
        <table className="w-full text-sm font-body">
          <thead>
            <tr className="bg-prussian text-white text-left uppercase text-[11px] tracking-wide">
              <th className="px-4 py-3 w-12">#</th>
              <th className="px-4 py-3">E-Mail-Adresse</th>
              <th className="px-4 py-3">Angemeldet am</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-edborder">
            {data.items.map((s, i) => (
              <tr key={s.id || s.email} className="hover:bg-offwhite">
                <td className="px-4 py-3 text-muted-foreground">{i + 1}</td>
                <td className="px-4 py-3 text-prussian font-medium">{s.email}</td>
                <td className="px-4 py-3 text-muted-foreground">{formatDateTime(s.created_at)}</td>
              </tr>
            ))}
            {data.items.length === 0 && <tr><td colSpan={3} className="text-center text-muted-foreground py-12">Noch keine Anmeldungen.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
